var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHorizontal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1021 1",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1021,
    height: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.3,0h1.4v1h-1.4V0ZM899.6,0h1.4v1h-1.4V0ZM879.9,0h1.4v1h-1.4V0ZM824.8,0h1.4v1h-1.4V0ZM884.5,0h1.4v1h-1.4V0ZM976.7,0h1.4v1h-1.4V0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.3,0h1.4v1h-1.4V0ZM659.6,0h1.4v1h-1.4V0ZM639.9,0h1.4v1h-1.4V0ZM584.8,0h1.4v1h-1.4V0ZM644.5,0h1.4v1h-1.4V0ZM736.7,0h1.4v1h-1.4V0Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.5,0h1.4v1h-1.4V0ZM451.9,0h1.4v1h-1.4V0ZM432.1,0h1.4v1h-1.4V0ZM377.1,0h1.4v1h-1.4V0ZM436.8,0h1.4v1h-1.4V0ZM528.9,0h1.4v1h-1.4V0Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.3,0h1.4v1h-1.4V0ZM319.6,0h1.4v1h-1.4V0ZM299.9,0h1.4v1h-1.4V0ZM244.8,0h1.4v1h-1.4V0ZM304.5,0h1.4v1h-1.4V0ZM396.7,0h1.4v1h-1.4V0Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.6,1h-1.4V0h1.4v1ZM123.3,1h-1.4V0h1.4v1ZM143,1h-1.4V0h1.4v1ZM198.1,1h-1.4V0h1.4v1ZM138.4,1h-1.4V0h1.4v1ZM46.3,1h-1.4V0h1.4v1Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHorizontal);
export default ForwardRef;